<template>
    <div>
        <div style="display: flex;margin-top: 20px;" @click="goOff()">
          <van-icon name="arrow-left" size="1.5em" />
          <span style="font-weight: 600;color: #000;">返回</span>
        </div>
        <div class="touyide">
            <div><img class="touxiang" :src="touxiang" alt=""></div>
            <div>
                <p style="margin-left: 18px;">{{nick}}</p>
            </div>
        </div>
        <div>
            <p style="margin-left: 20px;margin-top: 20px;">已加入<span>{{diff}}</span>天</p>
        </div>
        <van-tabs v-model="activeName" @click="onClick">
          <van-tab title="近十天数据" name="1">
            <div>
            <p style="margin-top: 20px;margin-left: 20px;">学习记录</p>
            <div class="xuexitou">
              <div class="biaoxiang">
                <div class="xiaotanyi" style="line-height: 50px;"><span>直播间名称</span></div>
              </div>
            </div>
            <div class="biaoxiang" style="margin-top: 10px;" v-for="(item, index) in xuexi" :key="index">
                <div class="xiaotanyi"><p style="margin-top: 11px;">{{item.name}}</p></div>
                <div class="xiaotaner" style="margin-left: 100px;">
                  <van-cell is-link @click="showPopup(item.channels)">详情</van-cell>
                  <van-popup v-model="show" :lock-scroll="false"	 closeable :style="{ height: '50%' }">
					   <p style="float: right;font-size: 18px;" @click="show = false">x</p>
                       <div>
                        <div class="xuexitou">
                          <div class="biaoxiang">
                            <div class="xiaotaner" style="line-height: 50px;"><span>进入时间</span></div>
                            <div class="xiaotansan" style="line-height: 50px;"><span>停留时间</span></div>
                          </div>
                        </div>
                        <div class="biaoxiang" style="margin-top: 10px;" v-for="(item1, index) in xiaodetan" :key="index">
                            <div class="xiaotaner"><span style="font-size: 12px;">{{item1.create_time}}</span></div>
                            <div class="xiaotansan"><span style="font-size: 12px;">{{ zhuanhuan(item1.second_time) }}</span></div>
                        </div>
                       </div>
                  </van-popup>
                </div>
            </div>
          </div>
          </van-tab>
          <van-tab title="十天以外数据" name="2">
            <div>
            <p style="margin-top: 20px;margin-left: 20px;">学习记录</p>
            <div class="xuexitou">
              <div class="biaoxiang">
                <div class="xiaotanyi" style="line-height: 50px;"><span>直播间名称</span></div>
              </div>
            </div>
            <div class="biaoxiang" style="margin-top: 10px;" v-for="(item, index) in xuexi" :key="index">
                <div class="xiaotanyi"><p style="margin-top: 11px;">{{item.name}}</p></div>
                <div class="xiaotaner" style="margin-left: 100px;">
                  <van-cell is-link @click="showPopup(item.channels)">详情</van-cell>
                  <van-popup v-model="show" :lock-scroll="false"	 closeable :style="{ height: '50%' }">
                       <div>
                        <div class="xuexitou">
                          <div class="biaoxiang">
                            <div class="xiaotaner" style="line-height: 50px;"><span>进入时间</span></div>
                            <div class="xiaotansan" style="line-height: 50px;"><span>停留时间</span></div>
                          </div>
                        </div>
                        <div class="biaoxiang" style="margin-top: 10px;" v-for="(item1, index) in xiaodetan" :key="index">
                            <div class="xiaotaner"><span style="font-size: 12px;">{{item1.create_time}}</span></div>
                            <div class="xiaotansan"><span style="font-size: 12px;">{{ zhuanhuan(item1.second_time) }}</span></div>
                        </div>
                       </div>
                  </van-popup>
                </div>
            </div>
          </div>
            <!-- <div>
                <p style="margin-top: 20px;margin-left: 20px;">学习记录</p>
                <div class="xuexitou">
                  <div class="biaoxiang">
                    <div class="xiaotanyi" style="line-height: 50px;"><span>直播间名称</span></div>
                    <div class="xiaotaner" style="line-height: 50px;"><span>进入时间</span></div>
                    <div class="xiaotansan" style="line-height: 50px;"><span>停留时间</span></div>
                  </div>
                </div>
                <div class="biaoxiang" style="margin-top: 10px;" v-for="(item, index) in xuexi" :key="index">
                    <div class="xiaotanyi"><span>{{item.itemzbmc}}</span></div>
                    <div class="xiaotaner"><span style="font-size: 12px;">{{item.create_time}}</span></div>
                    <div class="xiaotansan"><span style="font-size: 12px;">{{ zhuanhuan(item.second_time) }}</span></div>
                </div>
            </div> -->
          </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import qs from "qs";
	export default {
		data() {
			return {
        activeName: '0',
        touxiang: '',
        xuexi: [],
        show: false,
        xiaodetan: [],
		diff: '',
		nick: ''
			}
		},
		created(){
			this.studydata(1)
		},
		methods: {
      showPopup(index) {
        // console.log(index)
        this.xiaodetan = index
        this.show = true;
      },
      onClick(name, title) {
       console.log('ghssssss', name +1, title)
       this.studydata(name +1)
      },
      studydata(item) {
        // http://liveapi2.tenghuiwangxiao.com/api/ds/user/study_data
        var that = this;
				this.axios.post('http://liveapi2.tenghuiwangxiao.com/api/ds/user/study_data', qs.stringify({ fans_id: 1076933, type: item}))
				.then(function(data){
			        if(data.data.code == "200") {
                console.log('gsawwwwwwtttttttttttt---', data.data.data)
                that.xuexi = data.data.data.list
				that.diff = data.data.data.info.diff
				that.touxiang = data.data.data.info.header
				that.nick = data.data.data.info.nick
                // let xuexilist = [] 
                // data.data.data.list.forEach(item1=>{
                //   item1.channels.forEach(item2=>{
                //     item2.itemzbmc = item1.name
                //     console.log(item1.name)
                //     xuexilist.push(item2)
                //   })
                // })
                // that.xuexi = xuexilist
                // console.log('fshsssssssssss-----', xuexilist)
			        }
			    })
			},
      zhuanhuan(value) {
          let result = parseInt(value);
          let y =
              Math.floor(result / 86400) < 10
              ? "0" + Math.floor(result / 86400)
              : Math.floor(result / 86400);
          let h =
              Math.floor((result / 3600) % 24) < 10
              ? "0" + Math.floor((result / 3600) % 24)
              : Math.floor((result / 3600) % 24);
          let m =
              Math.floor((result / 60) % 60) < 10
              ? "0" + Math.floor((result / 60) % 60)
              : Math.floor((result / 60) % 60);
          let s =
              Math.floor(result % 60) < 10
              ? "0" + Math.floor(result % 60)
              : Math.floor(result % 60);
          let res = "";
          // if (y !== "00") res += `${y}天`;
           res += `${h}:`;
           res += `${m}:`;
           res += `${s}`;
          return res;
      },
      goOff(){
          this.$router.go(-1);
      },
		}
	}
</script>
<style scoped>
  .touyide {
    height: 68px;
    margin-top: 20px;
    display: flex;
  }
  .touxiang {
    width: 68px;
    height: 68px;
    border-radius: 34px;
    margin-left: 20px;
  }
  .xuexitou {
    margin-top: 20px;
    height: 50px;
    width: 100%;
    background: lightblue;
  }
  .biaoxiang {
    width: 336px;
    height: 50px;
    /* line-height: 50px; */
    display: flex;
    margin: 0 auto;
  }
  .xiaotanyi {
    width: 112px;
    height: 50px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .xiaotaner {
    width: 112px;
    height: 50px;
    text-align: center;
    /* overflow: hidden; */
  }
  .xiaotansan {
    width: 112px;
    height: 50px;
    text-align: center;
    /* overflow: hidden; */
  }
</style>